<template>
  <div>
    <div class="d-flex align-items-center justify-content-between mt-2">
      <b-button class="btn-add" variant="primary" @click="isShowAddUserModal = true">
        Thêm người dùng
      </b-button>
    </div>
    <div class="custom-search d-flex justify-content-end mb-2">
      <b-form-group>
        <div class="d-flex align-items-center">
          <label class="mr-1 text-nowrap">Tìm kiếm</label>
          <b-form-input
            v-model="searchTxt"
            placeholder="Tìm kiếm"
            type="text"
            class="d-inline-block"
          />
        </div>
      </b-form-group>
    </div>
    <b-modal v-model="isShowAddUserModal" title="Thêm người dùng" centered>
      <b-form-group label="Tên đăng nhập">
        <b-form-input
          placeholder="Nhập tên đăng nhập"
          type="text"
          v-model="addUsername"
        ></b-form-input>
      </b-form-group>
      <b-form-group label="Mật khẩu người dùng">
        <b-form-input
          placeholder="****"
          type="password"
          v-model="addPassword"
        ></b-form-input>
      </b-form-group>
      <template #modal-footer="{ cancel }">
        <b-button @click="cancel" class="btn-secondary">Hủy</b-button>
        <loading-button variant="primary" class="btn-adduser" @click="onAddUser">
          Thêm
        </loading-button>
      </template>
    </b-modal>

    <vue-good-table
      mode="remote"
      :columns="fields"
      :rows="tableItems"
      :total-rows="pagination.total"
      :is-loading="tableLoading"
      :pagination-options="{ enabled: true }"
      :line-numbers="true"
      @on-page-change="onPageChange"
      @on-per-page-change="onPerPageChange"
    >
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field === 'isDisabled'">
          <b-badge
            :variant="getStatusVariant(!props.row.isDisabled)"
            title="Nhấn để đổi trạng thái"
            class="cursor-pointer"
          >
            {{ getStatusText(!props.row.isDisabled) }}
          </b-badge>
        </span>

        <span v-else-if="props.column.field === 'money'">
          {{ formatPrice(props.row.money) }}
        </span>

        <span v-else-if="props.column.field === 'banks'">
          <div v-for="bank, index in props.row.banks" :key="index" style="text-wrap: nowrap;"> 
            <div v-if="bank.country">Quốc gia: <b>{{ bank.country }}</b></div>
            <div v-if="bank.province">Tỉnh/thành phố: <b>{{ bank.province }}</b></div>
            <div>Ngân hàng: <b>{{ bank.bankName }}</b></div>
            <div>STK: <b>{{ bank.accountNumber }}</b></div>
            <div>Chủ TK: <b>{{ bank.holder }}</b></div>
          </div>
        </span>

        <span v-else-if="props.column.field === 'createdAt'">
          {{ formatDateTime(props.row.createdAt) }}
        </span>

        <span v-else-if="props.column.field === 'action'">
          <action-user
            :user="props.row"
            @update:user="(e) => onUpdatedUser(props.row, e)"
            @delete:user="onDeleteUser"
          />
        </span>

        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <div slot="emptystate" class="text-center">
        Không có dữ liệu để hiển thị.
      </div>

      <div slot="loadingContent">
        <b-spinner variant="primary" />
      </div>
    </vue-good-table>
  </div>
</template>

<script>
import {
  BFormInput,
  BFormGroup,
  BBadge,
  BSpinner,
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
import debounce from "lodash.debounce";
import { formatDateTime, formatPrice } from "@/helpers/format";
import ActionUser from "@/components/Users/ActionUser.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import API from "@/api";

export default {
  components: {
    BFormInput,
    BFormGroup,
    BBadge,
    BSpinner,
    VueGoodTable,
    ActionUser,
  },

  data() {
    return {
      fields: [
        { field: "username", label: "Tên đăng nhập" },
        { field: "money", label: "Ví" },
        { field: "isDisabled", label: "Hoạt động" },
        { field: "ref", label: "Mã giới thiệu" },
        { field: "banks", label: "Ngân hàng" },
        { field: "createdAt", label: "Ngày tạo" },
        { field: "action", label: "Hành động" },
      ],
      tableItems: [],
      tableLoading: false,
      pagination: {
        perPage: 10,
        currentPage: 1,
        total: 0,
      },
      searchTxt: "",
      isShowAddUserModal: false,
      addUsername: "",
      addPassword: "",
    };
  },

  methods: {
    formatDateTime,
    formatPrice,
    
    onSearch: debounce(function () {
      this.fetchTableData(1, this.pagination.perPage);
    }, 500),

    async onAddUser() {
      if (!this.addUsername) {
        return this.$toast({
          component: ToastificationContent,
          props: {
            title: "Vui lòng nhập tên đăng nhập",
            icon: "EditIcon",
            variant: "danger",
          },
        });
      }
      if (!this.addPassword) {
        return this.$toast({
          component: ToastificationContent,
          props: {
            title: "Vui lòng nhập mật khẩu",
            icon: "EditIcon",
            variant: "danger",
          },
        });
      }
      if (this.addPassword < 6) {
        return this.$toast({
          component: ToastificationContent,
          props: {
            title: "Mật khẩu phải có ít nhất 6 chữ số",
            icon: "EditIcon",
            variant: "danger",
          },
        });
      }

      try {
        const submitData = {
          username: this.addUsername,
          password: this.addPassword,
        };
        const register = await this.$http.post(API.REGISTER_USER, submitData);
        if (register.success) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Đã thêm người dùng thành công",
              icon: "EditIcon",
              variant: "success",
            },
          });
          this.isShowAddUserModal = false;
          this.addUsername = "";
          this.addPassword = "";
          this.fetchTableData(this.pagination.currentPage, this.pagination.perPage);
        } else {
          console.log(register)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: register.message ? register.message :  'Failed',
              icon: "XIcon",
              variant: "danger",
            },
          });
        }
      } catch (error) {
        console.log(error, 'error')
        return this.$toast({
          component: ToastificationContent,
          props: {
            title: error?.message || "Error",
            icon: "EditIcon",
            variant: "danger",
          },
        });
      }
    },

    fetchTableData(page, size) {
      this.tableLoading = true;
      const params = { page, size };
      if (this.searchTxt) params.username = this.searchTxt;

      this.$http.get(API.USER_LIST, { params })
        .then((res) => {
          this.tableItems = res.data;
          this.pagination.total = res.total;
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },

    onPerPageChange({ currentPerPage }) {
      this.fetchTableData(1, currentPerPage);
    },

    onPageChange({ currentPage, currentPerPage }) {
      this.fetchTableData(currentPage, currentPerPage);
    },

    getStatusText(value) {
      return value ? "Đang hoạt động" : "Đang khóa";
    },

    getStatusVariant(value) {
      return value ? "success" : "danger";
    },

    onUpdatedUser(old, nw) {
      Object.assign(old, nw);
    },

    onDeleteUser() {
      // Refresh the table data after a user is deleted
      this.fetchTableData(this.pagination.currentPage, this.pagination.perPage);
    },
  },

  watch: {
    searchTxt(value) {
      this.onSearch();
    },
  },

  created() {
    this.fetchTableData(1, this.pagination.perPage);
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
.vs__open-indicator {
  fill: #aca9b7;
}
.btn-add {
  border-color: #7367f0 !important;
  background-color: #7367f0;
  border: 1px solid transparent;
  padding: .786rem 1.5rem;
  border-radius: .358rem;
  text-align: center;
  color: white;
  cursor: pointer;
}
.btn-secondary {
    color: $white;
    background: $gray-600;
    border-color: #82868b !important;
    border: 1px solid transparent;
    padding: .786rem 1.5rem;
    border-radius: .358rem;
    text-align: center;
    color: white;
    cursor: pointer;

  }
.btn-adduser {
  border-color: #7367f0 !important;
  background-color: #7367f0;
  border: 1px solid transparent;
  padding: .786rem 1.5rem;
  border-radius: .358rem;
  text-align: center;
  color: white;
  cursor: pointer;
}
</style>
